import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

export default function PointSelectionDot(props) {
  const useStyles = makeStyles(theme => ({
    root: {
      width: '16px',
      height: '16px',
      border: '3px Solid ' + props.color,
      borderRadius: '50%',
      backgroundColor: props.selected ? props.color : 'White',
    },
  }));

  const classes = useStyles();

  return <div className={classes.root} id={props.tag} />;
}
